<template>
  <div>
    <b-button
      id="btnOptimisation"
      onclick="location.href='/constructeur_portefeuille/selection_titres'"
    >
      <span class="btnText">Optimiser un nouveau portefeuille</span>
    </b-button>
  </div>
</template>
<script>
export default { prop: ["route"] };
</script>
<style lang="scss">
@import "../../../../../../../resources/sass/_variables.scss";

#btnOptimisation {
  background: $purple_color;
  border: none;
  border-radius: 15px;
  width: 50%;
  display: flex;
  align-items: center;
  margin: auto;
  .btnText {
    flex: 2;
  }
}
</style>